@import '../../styles/fonts.scss';
@import '../../styles/palette.scss';
@import '../../styles/deviceBreakpoints.scss';

.header {
  position: relative;
  margin: 2rem 0 1rem 0;

  .line {
    position: absolute;
    top: 0.8rem;
    border-bottom: 0.15rem solid _palette(header-line);
    height: 0;
    width: 100%;
    z-index: 1;

    @include target(mobile) {
      top: 0.6rem;
    }

    .customStatus {
      @include barlowMedium(16);
      position: absolute;
      right: 1rem;
      top: -0.75rem;
      border-radius: 18px;
      padding: 0.1rem 2rem;
    }
  }

  &.padLeft {
    .title {
      padding: 0.1rem 1.5rem 0.1rem 1rem;
      margin-left: 1rem;
    }

    .line {
      top: 0.9rem;

      @include target(mobile) {
        top: 0.7rem;
      }
    }
  }

  .title {
    @include barlow(18, 600);
    position: relative;
    background-color: _palette(bg-primary);
    color: _palette(secondary);
    width: -moz-fit-content;
    width: fit-content;
    height: 100%;
    padding-right: 1.5rem;
    z-index: 10;
    border-radius: 18px;

    @include target(mobile) {
      @include barlow(14, 600);
    }
  }

  .subtitle {
    @include barlow(14);
    position: relative;
    color: _palette(text-secondary-70);
    max-width: 75%;
    max-height: 100%;
    transition: max-height 0.15s ease-in-out;

    &.hide {
      max-height: 0;
      overflow: hidden;
    }

    @include target(mobile) {
      @include barlow(12);
    }
  }
}

.collapsible {
  outline-offset: 1.2rem;

  .line {
    .customStatus {
      right: 3rem;
    }
  }

  &.hovered:hover {
    cursor: pointer;

    .line {
      border-bottom: 0.175rem solid _palette(secondary-dark);
      .customStatus {
        background-color: _palette(secondary-dark);
        color: _palette(bg-secondary);
      }
    }

    .title {
      color: _palette(secondary-dark);
    }

    .arrow {
      fill: _palette(secondary-dark);
    }
  }

  .arrow {
    position: absolute;
    right: 0;
    top: -0.75rem;
    background-color: _palette(bg-primary);
    transform: scale(1.75);
    fill: _palette(secondary);
    z-index: 10;
  }
}

.children {
  transition: max-height 0.15s ease-in-out;
  max-height: 100%;

  &.hide {
    max-height: 0;
    overflow: hidden;
  }
}
